export default function ActivateTabFunc(sender, callback) {
  var index = sender.is("select") ? sender.prop('selectedIndex') + 1 : sender.index() + 1;

  $('.tabs-nav li').each(function () {
    $(this).removeClass('active');
  });
  
  var $tabsContent = $('.tab-content > div');
  var $selectedTabsContent = $tabsContent.filter('#tab' + index);

  $tabsContent.not($selectedTabsContent).fadeOut(100, function () {
    $selectedTabsContent.fadeIn();
  });

  if ($(".tab-panel select").length > 0 && $(sender)[0].nodeName == "LI") {
    $(".tab-panel select").prop("selectedIndex", index - 1);
  }
  
  $(sender).addClass('active');

  if (callback) {
    callback();
  }
}